import React from "react";

// Skeleton for the "Rapport hebdo" tab while data loads.
// Mirrors: 4 metric cards + a few list sections.
export default function WeeklyReportSkeleton() {
	return (
		<div className="weekly-skeleton" aria-busy="true" aria-label="Chargement du rapport hebdo">
			<div className="weekly-skeleton-metrics">
				{Array.from({ length: 4 }).map((_, i) => (
					<div key={i} className="weekly-skeleton-metric">
						<span className="skeleton skeleton-line" style={{ width: "45%", height: 26, margin: "0 auto 8px" }} />
						<span className="skeleton skeleton-line sm" style={{ width: "70%", margin: "0 auto 5px" }} />
						<span className="skeleton skeleton-line sm" style={{ width: "45%", margin: "0 auto" }} />
					</div>
				))}
			</div>

			{Array.from({ length: 3 }).map((_, i) => (
				<div key={i} className="weekly-skeleton-section">
					<span className="skeleton skeleton-line" style={{ width: 170, height: 13, marginBottom: 12 }} />
					{Array.from({ length: 3 }).map((__, j) => (
						<div key={j} className="weekly-skeleton-row">
							<span className="skeleton skeleton-line sm" style={{ width: `${40 + ((i * 7 + j * 11) % 25)}%` }} />
							<span className="skeleton skeleton-line sm" style={{ width: "18%" }} />
						</div>
					))}
				</div>
			))}
		</div>
	);
}
